import 'process';

import React from 'react';

import * as Sentry from '@sentry/react';
import { createRoot } from 'react-dom/client';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';

import App from './App';
import Loading from './components/elements/loading/Loading';

// import i18n
import './i18n';

const sentryDsn = import.meta.env.VITE_APP_SENTRY_DSN;

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
    ],
    tracesSampleRate: 1.0,
    environment: import.meta.env.VITE_APP_SENTRY_ENVIRONMENT,
  });
}

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
  <React.Suspense fallback={<Loading fullscreen />}>
    <App />
  </React.Suspense>
);
